import React from 'react'
import { PageTitle } from '../utils/GeneralFunction'
import Header from '../components/Header'
import Slider from '../components/Slider'
import Footer from '../components/Footer'
import HowNftWorks from '../components/HowNftWorks'
import TopCollections from '../components/TopCollections'
import TrendingCollectionsCategoryWise from '../components/TrendingCollectionsCategoryWise'
import TopAvatarsOnRent from '../components/TopAvatarsOnRent'
import LatestBlogs from '../components/LatestBlogs'

export default function Home() {

  PageTitle("Avatar Lab - The World's leading avatar platform");
  return (
    <>
        <Header />
        <Slider />
        <HowNftWorks />
        <TopCollections />
        <TrendingCollectionsCategoryWise />
        <TopAvatarsOnRent />
        <LatestBlogs />
        <Footer />
    </>
  )
}
